// Iris — sticky ATC mobile
// Règle : affiche la sticky quand l'utilisateur a scrollé PASSÉ l'ATC principal.
// Pas de check variant (la sticky peut servir à déclencher le scroll vers le
// variant-picker si rien n'est sélectionné, via son click handler).
// Tous les queries sont RE-FAITS à chaque interaction (Shopify peut re-render
// la section main-product après un variant change ou une app).

(function () {
  var MOBILE_BREAKPOINT = 767;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
  }

  function findAtc() {
    return document.querySelector('buy-buttons');
  }
  function findRealBtn() {
    var atc = findAtc();
    return atc ? atc.querySelector('button[type="submit"], input[type="submit"]') : null;
  }

  function init() {
    var sticky = document.querySelector('[data-iris-sticky-atc]');
    if (!sticky) return;
    if (!findAtc()) return;

    function show() {
      if (!isMobile()) return hide();
      sticky.hidden = false;
      sticky.setAttribute('aria-hidden', 'false');
      sticky.classList.add('is-visible');
    }
    function hide() {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
      sticky.hidden = true;
    }

    // Visibilité : sticky visible UNIQUEMENT quand l'utilisateur a scrollé
    // passé l'ATC principal (= bottom de l'ATC au-dessus du viewport).
    // On cache dans tous les autres cas, y compris :
    //  - ATC pas encore rendu (rect 0×0, custom element pas upgradé)
    //  - ATC encore dans le viewport
    //  - ATC en dessous du viewport (user n'est pas descendu jusqu'à lui)
    var scrollRaf = null;
    function checkVisibility() {
      scrollRaf = null;
      if (!isMobile()) return hide();
      var atc = findAtc();
      if (!atc) return hide();
      var r = atc.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return hide(); // pas encore rendu
      // scrolledPast : le bas de l'ATC est au-dessus du viewport (-ish)
      var scrolledPast = r.bottom < 40;
      if (scrolledPast) show();
      else hide();
    }
    function onScroll() {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(checkVisibility);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (!isMobile()) hide();
      else onScroll();
    });
    checkVisibility();

    // Click sticky : re-query à chaque click, jamais de ref cachée.
    var cta = sticky.querySelector('[data-iris-sticky-atc-cta]');
    if (cta) {
      cta.addEventListener('click', function () {
        var atc = findAtc();
        var realBtn = findRealBtn();
        var atcDisabled = realBtn && (realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true');

        if (atcDisabled) {
          // Pas de taille sélectionnée : scroll vers le 1er fieldset vide
          var formId = atc ? atc.getAttribute('form') : null;
          var radios = formId ? document.querySelectorAll('input[type="radio"][form="' + formId + '"][name*="option"]') : [];
          var groups = {};
          radios.forEach(function (r) {
            if (!groups[r.name]) groups[r.name] = [];
            groups[r.name].push(r);
          });
          var targetInput = null;
          for (var name in groups) {
            var hasChecked = groups[name].some(function (r) { return r.checked; });
            if (!hasChecked && groups[name][0]) { targetInput = groups[name][0]; break; }
          }
          var target = targetInput ? targetInput.closest('fieldset') : atc;
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            target.classList.add('iris-needs-attention');
            setTimeout(function () {
              target.classList.remove('iris-needs-attention');
            }, 1800);
          }
          return;
        }

        if (realBtn) {
          realBtn.click();
          return;
        }
        var formId2 = atc ? atc.getAttribute('form') : null;
        var form = formId2 ? document.forms[formId2] : null;
        if (form && form.requestSubmit) form.requestSubmit();
        else if (form) form.submit();
      });
    }

    // Update price on variant:change — écoute sur document (survit aux re-renders)
    document.addEventListener('variant:change', function (event) {
      var v = event.detail && event.detail.variant;
      if (!v) return;
      var priceEl = sticky.querySelector('[data-iris-sticky-atc-price]');
      if (!priceEl) return;
      var money = function (cents) {
        var s = (cents / 100).toFixed(2).replace('.', ',');
        return s + ' €';
      };
      var html = '';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html += '<span class="iris-sticky-atc__old">' + money(v.compare_at_price) + '</span>';
      }
      html += '<span class="iris-sticky-atc__new">' + money(v.price) + '</span>';
      priceEl.innerHTML = html;
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
